import type { ReactNode } from 'react';

export const UsageChartTooltip = ({ children }: { children: ReactNode }) => (
  <div className="rounded-md bg-accent px-2.5 py-2 text-xs text-accent-foreground">
    {children}
  </div>
);
